import { render } from "./HomeBody.vue?vue&type=template&id=31e2ddf2&scoped=true"
import script from "./HomeBody.js?vue&type=script&lang=js"
export * from "./HomeBody.js?vue&type=script&lang=js"

import "./HomeBody.css?vue&type=style&index=0&id=31e2ddf2&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31e2ddf2"]])

export default __exports__